import { useQuery } from "@tanstack/react-query";
import { getAllTeachers } from "../../api/apiTeachers";
import i18next from "i18next";

export function useGetTeachers(page = 1, perPage = 15, filters = {}) {
    const { isLoading, data, error } = useQuery({
        queryKey: ["teachers", page, perPage, filters, i18next.language],
        queryFn: () => getAllTeachers(page, perPage, filters),
        retry: false,
    });
    const teachers = data?.data?.items || [];
    const meta = data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 };
    return { isLoading, error, teachers, meta };
}
